import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load organizations.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const fetchOrganizations = async () => {
  const response = await fetch(`${API_BASE}/api/organizations`);
  return handleResponse(response);
};

export const fetchOrganizationsForAdmin = async (token) => {
  const response = await fetch(`${API_BASE}/api/organizations/manage`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const fetchOrganizationAdmins = async (token) => {
  const response = await fetch(`${API_BASE}/api/organizations/admins`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load organization admins.');
};

export const createOrganization = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/manage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create organization.');
};

export const createOrganizationAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create organization admin.');
};

export const deleteOrganization = async (organizationId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/${organizationId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete organization.');
};

export const deleteOrganizationAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete organization admin.');
};

export const fetchOrganizationOfficials = async (organizationId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/${organizationId}/officials`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load organization officials.');
};


export const archiveOrganization = async (organizationId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/organizations/${organizationId}/archive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to archive organization.');
};

export const unarchiveOrganization = async (organizationId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/organizations/${organizationId}/unarchive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to unarchive organization.');
};
